import {Select} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {EmpresaUnidade} from '../../constants';

const {Tipo} = EmpresaUnidade;

export default function SelectEmpresaUnidadeTipo(props) {
  const {t} = useTranslation();

  const createOption = ({id, label}) => (
      <Select.Option value={id}>
        {t(label)}
      </Select.Option>);

  return (
      <Select {...props} >
        {createOption(Tipo.Matriz)}
        {createOption(Tipo.Filial)}
      </Select>
  );
}

SelectEmpresaUnidadeTipo.propTypes = {
  value: PropTypes.oneOf([
    Tipo.Matriz.id,
    Tipo.Filial.id]),
  onChange: PropTypes.func,
};
